import Breadcrumb from '@/components/base/Breadcrumb';
import { FAQ_GROUPS } from '@/mocks/faq';

export default function FaqHero() {
  const total = FAQ_GROUPS.reduce((sum, g) => sum + g.items.length, 0);

  return (
    <section className="w-full px-4 md:px-6 pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100">
      <div className="max-w-6xl mx-auto w-full">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '常见问题' }]} />

        <h1 className="mt-6 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-3xl">
          爆料大赛常见问题
        </h1>
        <p className="mt-5 max-w-3xl text-sm md:text-base text-foreground-600 leading-relaxed">
          关于赛程时间、报名投稿、投票评审与结果奖励的 {total} 个高频问题，按类别整理在下面。找不到答案可以到关于我们页留下联系方式。
        </p>

        <nav aria-label="问题分类" className="mt-8 flex flex-wrap gap-2">
          {FAQ_GROUPS.map((g) => (
            <a
              key={g.id}
              href={`#${g.id}`}
              className="px-4 py-2 rounded-full bg-background-50 border border-background-200 text-xs md:text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              {g.title}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
}